/**
 * Portfolio Filter Logic
 * Handles filtering of case study cards based on technology tags
 */
export default class PortfolioFilter {
    constructor() {
        this.filterBtns = document.querySelectorAll('.filter-btn');
        this.portfolioCards = document.querySelectorAll('.case-study-card');

        // Initial filter state from URL hash or default 'all'
        this.currentFilter = 'all';

        this.init();
    }

    init() {
        if (!this.filterBtns.length || !this.portfolioCards.length) return;

        // Add click event listeners to filter buttons
        this.filterBtns.forEach(btn => {
            btn.addEventListener('click', (e) => {
                const filterValue = e.target.getAttribute('data-filter');
                this.setFilter(filterValue);
            });
        });

        // Check URL hash for filter on load
        this.checkHashFilter();

        // Listen for hash changes
        window.addEventListener('hashchange', () => this.checkHashFilter());
    }

    checkHashFilter() {
        const hash = window.location.hash.replace('#', '');
        if (hash && hash.startsWith('filter-')) {
            const filter = hash.replace('filter-', '');
            // Check if filter exists
            const filterBtn = document.querySelector(`.filter-btn[data-filter="${filter}"]`);
            if (filterBtn) {
                this.setFilter(filter);
            }
        }
    }

    setFilter(filter) {
        if (this.currentFilter === filter) return;
        this.currentFilter = filter;

        // Update active button state
        this.filterBtns.forEach(btn => {
            if (btn.getAttribute('data-filter') === filter) {
                btn.classList.add('active');
            } else {
                btn.classList.remove('active');
            }
        });

        // Filter cards
        this.portfolioCards.forEach(card => {
            const tags = card.getAttribute('data-tags');

            // Reset animation classes
            card.classList.remove('show');

            if (filter === 'all' || (tags && tags.includes(filter))) {
                card.classList.remove('hide');
                // Trigger reflow to restart animation
                void card.offsetWidth;
                card.classList.add('show');
            } else {
                card.classList.add('hide');
            }
        });
    }
}
